import React from 'react'
import { BoxProps, Text } from '@chakra-ui/core'
import colors from 'constants/colors'
import LocaleText from 'components/LocaleText'

/**
 * Shared section header component for filtering views
 */
export const SectionHeader = ({ title, ...props }: { title: string } & BoxProps) => (
  <Text fontSize="14px" fontWeight="normal" color={colors.blackLight} mb="10px" {...props}>
    <LocaleText text={title} />
  </Text>
)
